import { DITypes } from "@/core/@types/types";
import type { HttpClient, IHttpMiddlewareIntercept } from "./protocols/types";
import { inject, injectable, optional } from "inversify";

@injectable()
export default class HttpMiddlewareIntercept
  implements IHttpMiddlewareIntercept
{
  @inject(DITypes.FINANCAS_HTTP_CLIENT)
  @optional()
  httpClient!: HttpClient;

  async sendFinancasToken(): Promise<void> {
    this.httpClient.post({
      url: "/refreshCookie"
    });
  }
}
